import script from "./MaintenanceScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./MaintenanceScreen.vue?vue&type=script&setup=true&lang=js"

import "./MaintenanceScreen.vue?vue&type=style&index=0&id=4c19a39e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c19a39e"]])

export default __exports__